export enum Route {
  Dashboard = "/",
  Opportunities = "/opportunities",
  Ilians = "/ilians",
  IliansDetails = "/ilians/details/:id",
}
